export const ActionTypes = {
  LOADING: "RESET_PASSWORD_LOADING",
  ERROR: "RESET_PASSWORD_ERROR",
  SUCCESS: "RESET_PASSWORD_SUCCESS",
};
